import Docs from '/src/data/auto-generated/pwa-buildpack/lib/BuildBus/BuildBus.md';
import * as React from 'react';
export default {
  Docs,
  React
};